import * as React from 'react';

import { ListProductionsProps } from '../../components/list/productions';
import ListProduction from '../../components/list/production';
import LoaderView from 'addons-loader.view';


const ListProductionsView: React.StatelessComponent<ListProductionsProps> = props => {
    function reserveText(): string {
        if (props.itemsToReserve > 0) {
            return props.text.reserveAddOnsWithItemsLabel.replace("{0}", props.itemsToReserve.toString());
        } else {
            return props.text.reserveAddOnsLabel;
        }
    }
    return (
        <>
            <section className="ace-layout ace-layout-8-4">
                <div>
                    {
                        props.text.productionListHeading ?
                            <h2>{props.text.productionListHeading}</h2>
                            : null
                    }
                    <ul className="no-bullets space-top">
                        {
                            props.productions.map(prod => <ListProduction key={`${prod.id}`}
                                production={prod} displayLoading={props.displayLoading} />)
                        }
                    </ul>

                    {props.reserveFailed ?
                        <div className="validation-summary-errors">
                            <ul>
                                <li>{props.text.reserveFailedErrorMessage}</li>
                            </ul>
                        </div>
                        : null}
                </div>
                <div data-sticky-container>
                    <div className="ace-minicart" id="miniCart" data-margin-top="48" data-sticky-for="1024" data-sticky-class="stuck">
                        <div className="ace-minicart-inner" data-sticky-inner>
                            <div className="stack stack-border">
                                <div className="flex-between">
                                    <span>{props.text.minicartTotalsLabel}</span>
                                    <span className="bold">${props.addOnsTotal.toFixed(2)}</span>
                                </div>
                                <div className="space-top border-top stack-md">
                                    <a href={props.text.skipButtonRedirectUrl} className="btn-secondary btn-full-width">{props.text.skipLabel}</a>
                                    <button className="btn btn-full-width" disabled={props.itemsToReserve == 0} onClick={eve => props.reserveAddons()}>{reserveText()}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {props.loading ? <LoaderView text={props.text} isProcessing={props.loading} /> : null}
        </>
    )
}
export default ListProductionsView;